// src/components/common/CustomDatagrid.tsx - Wrapper que decide desktop vs mobile
import React from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useListContext, useTranslate, DatagridProps, RaRecord } from 'react-admin';
import CustomDataGridDesktop from './CustomDataGridDesktop';
import CustomDataGridMobile from './CustomDataGridMobile';
import NoDataMessage from './NoDataMessage';

interface CustomDataGridProps<RecordType extends RaRecord = any> extends DatagridProps<RecordType> {
  children: React.ReactNode;
}

/**
 * CustomDataGrid - Wrapper que decide entre versión desktop y mobile
 * Mantiene la arquitectura existente que ya funciona
 */
const CustomDatagrid = <RecordType extends RaRecord = any>({ 
  ...props 
}: CustomDataGridProps<RecordType>) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { data = [], isLoading } = useListContext();
  const translate = useTranslate();

  // Decide cuál componente usar según el tamaño de pantalla
  const Component = isMobile ? CustomDataGridMobile : CustomDataGridDesktop;

  // Estado vacío - usa NoDataMessage existente
  if (!isLoading && data.length === 0) {
    return (
      <NoDataMessage
        title={translate('pages.dashboard.no_devices')}
        description={translate('pages.dashboard.no_devices_description')}
      />
    );
  }

  return <Component {...props} />;
};

export default CustomDatagrid;